import { TextField } from "src/components/FormikComponents/TextField";

interface IDefinitionPlannedCreditProps {
  initialValue: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const DefinitionPlannedCredit = (props: IDefinitionPlannedCreditProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = initialValue !== value;

  return (
    <TextField
      className={`plannedcredit_control ${isDirty ? "dirty" : ""}`}
      label="Planned Credit"
      value={value}
      onChange={(event: any) => onChange(event?.target?.value)}
      meta={{
        initialValue: initialValue,
        touched: isDirty,
      }}
      disabled={disabled}
    />
  );
};
